import { reviews } from '@/mocks/comics';

export default function ReviewSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50 relative overflow-hidden">
      <div className="absolute top-0 left-0 w-64 h-64 pointer-events-none opacity-10">
        <i className="ri-double-quotes-l text-[200px] text-primary-500"></i>
      </div>
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 text-center mb-12 whitespace-nowrap">
          读者<span className="text-primary-500">评价</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {reviews.map((review) => (
            <article key={review.id} className="relative bg-secondary-900 rounded-lg overflow-visible p-6 md:p-8">
              <div className="absolute -top-5 left-6 w-12 h-12 rounded-lg overflow-hidden border-4 border-background-50">
                <img
                  src={review.avatar}
                  alt={review.username}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="mt-6 mb-4">
                <i className="ri-double-quotes-l text-2xl text-accent-400/60"></i>
              </div>
              <p className="text-sm text-background-50/80 leading-relaxed mb-6 line-clamp-5">
                {review.content}
              </p>
              <div className="border-t border-foreground-800/30 pt-4">
                <p className="text-sm font-semibold text-background-50 whitespace-nowrap">{review.username}</p>
                <p className="text-xs text-foreground-400 mt-1 whitespace-nowrap">
                  {review.level} · {review.date}
                </p>
              </div>
              <div className="mt-4">
                <button className="px-5 py-2 rounded-full bg-accent-100/80 text-accent-900 text-xs font-medium hover:bg-accent-200/80 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                  查看全文
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}